import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    statusUrl: String,
    pollInterval: { type: Number, default: 1500 },
  }

  connect() {
    if (!this.hasStatusUrlValue) return

    this.poll()
    this.timer = window.setInterval(() => this.poll(), this.pollIntervalValue)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  async poll() {
    try {
      const response = await window.fetch(this.statusUrlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })

      if (!response.ok) return

      const data = await response.json()
      if (data.state === "processing") return

      if (this.timer) window.clearInterval(this.timer)

      if (window.Turbo) {
        window.Turbo.visit(window.location.href, { action: "replace" })
      } else {
        window.location.reload()
      }
    } catch {
      // Ignore transient network errors; keep polling.
    }
  }
}
